import React from 'react'
import Header from './Header'
import Hero from './Hero'
import HowItWorks from '../Component/HowItWorks'
import AboutUs from '../Component/AboutUs'
import Footer from '../Component/Footer'
import Contact from '../Component/Contact'
import FAQ from '../Component/FAQ'
import Reviews from './Review'
import TapCounter from './TapCounter'
import WhatsAppButton from './WhatsAppButton'


function HomePage() {
  return (
    <div>
  <Header/>
<WhatsAppButton/>
  <Hero/>
<HowItWorks/>
<Reviews/>
<AboutUs/>
<TapCounter/>
<FAQ/>
<Contact/>
<Footer/>

    </div>
 

  )
}

export default HomePage